import { Heading } from '@mm/components';
import { CloseIcon } from '@mm/icons';
import { useFeatureFlagsCRUDActions } from '@mm/state/actions/FeatureFlagsCRUDActions';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import {
  ConnectableChannel,
  useChannelConnection,
} from '../../../editor/features/beta/modules/Automations/AutomationEdit/InputTriggers/use-channel-connection';
import { ChannelInfo } from '../../../editor/features/beta/modules/Automations/AutomationHome/TemplateIndex/TemplateGoButton';
import { ModalInstanceProps } from '../interfaces';
import styles from './ConnectChannelModal.module.css';
import emailIcon from './Icons/email.svg';
import facebookIcon from './Icons/facebook.svg';
import instagramIcon from './Icons/instagram.svg';
import smsIcon from './Icons/sms.svg';
import webchatIcon from './Icons/webchat.svg';

type Props = ModalInstanceProps & {
  channels: ConnectableChannel[];
  facebookPage: EnhancedBillingPage;
  title?: string;
  subTitle?: string;
};

export const ConnectChannelModal = (props: Props) => {
  const { channels, facebookPage, closeModal, title, subTitle } = props;
  const featureFlagsCRUDActions = useFeatureFlagsCRUDActions();
  const { connectChannel } = useChannelConnection(
    () => {},
    undefined,
    false,
    facebookPage,
  );

  useEffect(() => {
    featureFlagsCRUDActions.retrieveSubscriptionFeatures(facebookPage.id);
  }, [facebookPage.id, featureFlagsCRUDActions]);

  return (
    <div className={styles.container}>
      <CloseIcon
        color="#8c8c8c"
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />
      <div className={styles.headerIcons}>
        {[facebookIcon, webchatIcon, instagramIcon, smsIcon, emailIcon].map(
          icon => {
            return <img src={icon} key={icon} />;
          },
        )}
      </div>
      <div className={styles.content}>
        <Heading size={3} className={styles.heading}>
          {title ? title : 'Connect a New Channel'}
        </Heading>
        {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
        <div
          className={classNames(styles.buttonsWrapper, {
            [styles.singleRow]: channels?.length === 1,
          })}
        >
          {channels.map(channel => {
            return (
              <div
                className={styles.button}
                key={channel}
                onClick={() => connectChannel(channel)}
              >
                <ChannelInfo channel={channel} width={35} height={35} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
